import React from "react";

function Bank2Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.51071 0.0996094L0.760707 3.84961C0.213832 4.08398 -0.0908559 4.66992 0.0302378 5.24805C0.151332 5.82617 0.659144 6.24805 1.25289 6.24805V6.56055C1.25289 7.08008 1.67086 7.49805 2.19039 7.49805H17.8154C18.3349 7.49805 18.7529 7.08008 18.7529 6.56055V6.24805C19.3466 6.24805 19.8584 5.83008 19.9755 5.24805C20.0927 4.66602 19.7881 4.08008 19.2451 3.84961L10.4951 0.0996094C10.1826 -0.0332031 9.82321 -0.0332031 9.51071 0.0996094ZM5.00289 8.74805H2.50289V16.416C2.47946 16.4277 2.45602 16.4434 2.43258 16.459L0.557582 17.709C0.10055 18.0137 -0.106481 18.584 0.0536753 19.1113C0.213832 19.6387 0.702113 19.998 1.25289 19.998H18.7529C19.3037 19.998 19.7881 19.6387 19.9482 19.1113C20.1084 18.584 19.9052 18.0137 19.4443 17.709L17.5693 16.459C17.5459 16.4434 17.5224 16.4316 17.499 16.416V8.74805H15.0029V16.248H13.4404V8.74805H10.9404V16.248H9.06539V8.74805H6.56539V16.248H5.00289V8.74805ZM10.0029 2.49805C10.3344 2.49805 10.6524 2.62974 10.8868 2.86416C11.1212 3.09858 11.2529 3.41653 11.2529 3.74805C11.2529 4.07957 11.1212 4.39751 10.8868 4.63193C10.6524 4.86635 10.3344 4.99805 10.0029 4.99805C9.67137 4.99805 9.35343 4.86635 9.11901 4.63193C8.88459 4.39751 8.75289 4.07957 8.75289 3.74805C8.75289 3.41653 8.88459 3.09858 9.11901 2.86416C9.35343 2.62974 9.67137 2.49805 10.0029 2.49805Z"
        fill="white"
      />
    </svg>
  );
}

export default Bank2Icon;
